import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  margin-bottom: 1.25rem;
  justify-content: flex-end;
`;
